import { useTranslation } from 'react-i18next';
import { ErrorSummary } from '@digdir/designsystemet-react';

import { useAdvancedSearchFormContext } from '../../types';

export const FormErrors = () => {
  const { formState } = useAdvancedSearchFormContext();
  const { t } = useTranslation();

  let errorList = Object.entries(formState.errors);
  if (errorList.length === 0) {
    return null;
  }

  const hasRequiredFieldCombinationError = errorList.find(([key]) => {
    return key === 'gardsnummer' || key === 'bruksnummer' || key === 'bygningsnummer';
  });

  //if any of the  gardsnummer and bruksnummer and bygningsnummer is in error list remove all
  //and add custom error for this case
  if (hasRequiredFieldCombinationError) {
    errorList = errorList.filter(([key]) => {
      return key !== 'gardsnummer' && key !== 'bruksnummer' && key !== 'bygningsnummer';
    });
    errorList.push(['requiredFieldCombination', { message: t('search.advanced.error.requiredFieldCombination') }]);
  }

  return (
    <ErrorSummary>
      <ErrorSummary.Heading>{t('search.advanced.error.description')}</ErrorSummary.Heading>

      <ErrorSummary.List>
        {errorList.map(([key, error]) => (
          <ErrorSummary.Item key={key} aria-label={error.message}>
            {error.message}
          </ErrorSummary.Item>
        ))}
      </ErrorSummary.List>
    </ErrorSummary>
  );
};
